
import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { businessInfo } from '@/data/businessInfo';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <h1 className="text-4xl font-serif font-bold mb-8 text-pkstone-900">Privacy Policy</h1>
            <p className="text-pkstone-600 mb-4">Last updated: March 2026</p>
            
            <h2 className="text-2xl font-serif font-bold mt-8 mb-4">Information We Collect</h2>
            <p>When you use our website or contact us, we may collect:</p>
            <ul>
              <li>Name, email address, phone number, and mailing address when you submit a contact form</li>
              <li>Information about your property and project requirements</li>
              <li>Usage data collected automatically through cookies and analytics tools (Google Analytics)</li>
            </ul>

            <h2 className="text-2xl font-serif font-bold mt-8 mb-4">How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Respond to your inquiries and provide service estimates</li>
              <li>Deliver and improve our landscaping services</li>
              <li>Send relevant communications about our services</li>
              <li>Analyze website usage to improve user experience</li>
            </ul>

            <h2 className="text-2xl font-serif font-bold mt-8 mb-4">Cookies & Analytics</h2>
            <p>
              We use Google Analytics and Google Tag Manager to understand how visitors interact with our website. 
              These tools use cookies to collect anonymous usage data. You can opt out by adjusting your browser settings 
              or using the Google Analytics opt-out browser add-on.
            </p>

            <h2 className="text-2xl font-serif font-bold mt-8 mb-4">Data Sharing</h2>
            <p>
              We do not sell your personal information. We may share data with service providers who assist 
              in operating our website and delivering services, subject to confidentiality agreements.
            </p>

            <h2 className="text-2xl font-serif font-bold mt-8 mb-4">Your Rights</h2>
            <p>
              You may request access to, correction of, or deletion of your personal information 
              by contacting us at <a href={`mailto:${businessInfo.email}`} className="text-pkgreen-600 hover:text-pkgreen-700">{businessInfo.email}</a>.
            </p>

            <h2 className="text-2xl font-serif font-bold mt-8 mb-4">Contact</h2>
            <p>
              For questions about this privacy policy, contact us at:<br />
              {businessInfo.name}<br />
              {businessInfo.address.full}<br />
              {businessInfo.email}<br />
              {businessInfo.phone}
            </p>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
